<template>
  <div class="fixed inset-y-0 z-50 flex w-72 flex-col">
    <div
      class="flex grow flex-col gap-y-3 overflow-y-auto border-r border-gray-200 bg-white dark:bg-gray-900 dark:border-gray-900 px-6 pb-4"
    >
      <div class="flex h-16 shrink-0 items-center justify-between">
        <!-- <img class="h-8 w-auto" src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=primary&shade=500" alt="Your Company" /> -->
        <span class="text-2xl font-semibold text-gray-900 dark:text-white">
          Chilli Penguin
        </span>
        <DarkModeToggle></DarkModeToggle>
      </div>
      <nav class="flex flex-1 flex-col">
        <ul role="list" class="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" class="-mx-2 space-y-1">
              <li v-for="item in navigation" :key="item.name">
                <a
                  :href="item.href"
                  :class="[
                    item.current
                      ? 'bg-gray-50 text-primary-600 dark:bg-gray-800 dark:text-white'
                      : 'text-gray-700 hover:bg-gray-50 hover:text-primary-600 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white',
                    'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                  ]"
                >
                  <component :is="item.icon" :size="24" aria-hidden="true" />
                  {{ item.name }}
                </a>
              </li>
            </ul>
          </li>
          <!-- <li class="mt-auto">
              <a href="#" class="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-700 hover:bg-gray-50 hover:text-primary-600 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white">
                <PhGear :size="24" aria-hidden="true"/>
                Settings
              </a>
            </li> -->
        </ul>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { PhHeart } from "@phosphor-icons/vue";
import DarkModeToggle from "@/components/DarkModeToggle.vue";

const navigation = [
  {
    name: "Link 1",
    href: route("dashboard"),
    icon: PhHeart,
    current: route().current("dashboard"),
  },
  { name: "Link 2", href: "#", icon: PhHeart, current: false },
];
</script>
